import portrait from '../images/Maycie.jpg';
import { Arrow } from './ui';

export function Hero() {
  return (
    <section className="hero container" id="home" aria-labelledby="hero-heading">
      <div className="hero-copy">
        <p className="eyebrow hero-intro">Maycie Morris <span aria-hidden="true">/</span> Front-end developer</p>
        <h1 id="hero-heading">Hi, I’m Maycie.<br />I build for <span className="hand-underline">the web.</span></h1>
        <p className="hero-description">I’m a front-end developer specializing in thoughtful interfaces, custom functionality, and e-commerce development.</p>
        <p className="hero-description">Since 2022, I’ve been the front-end developer at Stickley, working across storefront development, integrations, and technical problem-solving.</p>
        <div className="hero-actions">
          <a className="button button-dark" href="#work">View My Work <Arrow direction="down" /></a>
          <a className="text-link" href="#contact">Get in Touch <Arrow /></a>
        </div>
      </div>
      <figure className="hero-portrait">
        <div className="portrait-mat">
          <span className="photo-tape" aria-hidden="true" />
          <div className="portrait-image"><img src={portrait} alt="Maycie Morris" width="1080" height="1080" fetchpriority="high" /></div>
          <div className="portrait-bottomline">Maycie Morris</div>
        </div>
        <figcaption><span className="availability-dot" /> Open to select freelance projects</figcaption>
      </figure>
      <div className="hero-footnote">
        <p>Currently: <a href="https://www.stickley.com/" target="_blank" rel="noreferrer">Stickley <Arrow /></a></p>
        <p>Front-end development <span aria-hidden="true">·</span> E-commerce <span aria-hidden="true">·</span> Integrations</p>
      </div>
    </section>
  );
}
